import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { map } from 'rxjs/operators';
import { UtilDadosLogado } from './util.logado';

@Injectable()
export class UtilServico {
  constructor(private http: Http, private UtilDadosLogado: UtilDadosLogado) {}

  Url() {
    return this.http.get('assets/config.json').pipe(map((res: Response) => res.json()));
  }

  Get(metodo: string) {
    return this.http.get(this.UtilDadosLogado.DadosAcesso().url + '/api/' + metodo, this.jwt()).pipe(map((res: Response) => res.json()));
  }

  Delete(metodo: string) {
    return this.http.delete(this.UtilDadosLogado.DadosAcesso().url + '/api/' + metodo, this.jwt()).pipe(map((res: Response) => res.json()));
  }

  Put(metodo: string, dados: any, upper: boolean) {
    Object.keys(dados).forEach(function(key) {
      if (typeof dados[key] === 'string') {
        if (upper) {
          dados[key] = String(dados[key])
            .toUpperCase()
            .replace(/^\s+|\s+$/g, '');
        } else {
          dados[key] = String(dados[key]).replace(/^\s+|\s+$/g, '');
        }
      }
    });

    return this.http
      .put(this.UtilDadosLogado.DadosAcesso().url + '/api/' + metodo, dados, this.jwt())
      .pipe(map((res: Response) => res.json()));
  }

  Post(metodo: string, dados: any, upper: boolean) {
    Object.keys(dados).forEach(function(key) {
      if (key != "avatar" && typeof dados[key] === 'string') {
        if (upper) {
          dados[key] = String(dados[key])
            .toUpperCase()
            .replace(/^\s+|\s+$/g, '');
        } else {
          dados[key] = String(dados[key]).replace(/^\s+|\s+$/g, '');
        }
      }
    });

    return this.http
      .post(this.UtilDadosLogado.DadosAcesso().url + '/api/' + metodo, dados, this.jwt())
      .pipe(map((res: Response) => res.json()));
  }

  async Post2(metodo: string, dados: any) {
    Object.keys(dados).forEach(function(key) {
      if (typeof dados[key] === 'string') {
        dados[key] = String(dados[key])
          .toUpperCase()
          .replace(/^\s+|\s+$/g, '');
      }
    });

    await this.http.post(this.UtilDadosLogado.DadosAcesso().url + '/api/' + metodo, dados, this.jwt()).toPromise();
  }

  PostDownload(metodo: string, dados: any) {
    return this.http
      .post(this.UtilDadosLogado.DadosAcesso().url + '/api/' + metodo, dados, this.jwt2())
      .pipe(map((res: Response) => res.json()));
  }

  GetDownload(metodo: string) {
    return this.http.get(this.UtilDadosLogado.DadosAcesso().url + '/api/' + metodo, this.jwt2()).pipe(map((res: Response) => res.json()));
  }

  Login(url: string, metodo: string, dados: any) {
    return this.http.post(url + '/api/' + metodo, dados, this.jwt2()).pipe(map((res: Response) => res.json()));
  }

  private jwt() {
    let dados = JSON.parse(localStorage.getItem('DadosAcesso'));
    if (dados && dados.token) {
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', Authorization: 'Bearer ' + dados.token });
      return new RequestOptions({ headers: headers });
    }
  }

  private jwt2() {
    let dados = JSON.parse(localStorage.getItem('DadosAcesso'));
    if (dados && dados.token) {
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', Authorization: 'Bearer ' + dados.token });
      return new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    }
  }
}
